import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import {
  LeadsRequest,
  LeadsResponse,
  LeadViewRequest,
  LeadCreateRequest,
  LeadCreateResponse,
  LeadUpdateRequest,
  LeadUpdateResponse,
  LeadContactsResponse,
} from "./types";
import { Lead } from "@/model/lead";

const defaultLeadExpand: Array<keyof Omit<Lead, "id" | "name">> = [
  "status",
  "responsible_user",
  "source",
  "contact",
  "site",
  "comments",
  "nda",
  "form",
  "nda_call",
  "created_at",
];

export const leads = (data?: LeadsRequest): AxiosPromise<LeadsResponse> => {
  const { limit, offset, search, sort_column, sort_direction, ...rest } = data?.params?.filters || {};
  return axiosInstance.get(`/leads?expand=${data?.params?.expand?.join(",") || ""}`, {
    params: {
      limit,
      offset,
      search,
      sort_column,
      sort_direction,
      ...rest,
    },
  });
};

export const lead = (data?: LeadViewRequest): AxiosPromise<Lead> => {
  const { id, expand } = data?.params || {};
  const expandString = expand?.length ? expand.join(",") : defaultLeadExpand.join(",");
  return axiosInstance.get(`/lead/${id}/view?expand=${expandString}`, {
    params: {
      id,
    },
  });
};

export const leadCreate = (params: LeadCreateRequest): AxiosPromise<LeadCreateResponse> => axiosInstance.post(`/lead/create`, params);

export const leadUpdate = (data: LeadUpdateRequest): AxiosPromise<LeadUpdateResponse> => axiosInstance.post(`/lead/${data.id}/update`, data.body);

export const leadDelete = (id: number): AxiosPromise<undefined> => axiosInstance.post(`/lead/${id}/delete`);

export const leadContacts = (): AxiosPromise<LeadContactsResponse> => axiosInstance.get(`/lead/contacts`);
